/*eslint-disable */

import PDFUploader from '@/components/common/pdfViewer/PDFUploader.vue'
import PDFViewer from '@/components/common/pdfViewer/PDFViewer.vue'
import {
  bus
} from '@/main';

var $ = window.jQuery = require('jquery');

export default {
  name: 'pdf-viewer',
  components: {
    PDFUploader,
    PDFViewer
  },
  props: [
    'pdfViewerURL',
    'pdfViewerFileNAME'
  ],
  data () {
    return {
      url:'',
      documentError: undefined,
      enableUploader: process.env.VUE_APP_UPLOAD_ENABLED === 'true',
    }
  },
  computed: {

  },
  mounted () {
    // console.log(this.pdfViewerURL, "Please Check the pdf url")
    this.url = this.pdfViewerURL

  },
  methods: {
    urlUpdated(url) {
      this.documentError = undefined;
    },
    onDocumentErrored(e) {
      this.documentError = e.text;
    },
    pdfViewerCloseFun(){
      bus.$emit('pdfViewerPopupBus', false);
      $('body').removeClass("overflow-hidden")
      $('body').removeClass("pdf_view_actv")
    },
  }
}


